import { GET_SUMSUB_TOKEN_REQUEST } from "./constants";

export const getSumSubTokenRequest = (data) => {
  return {
    type: GET_SUMSUB_TOKEN_REQUEST,
    data,
  };
};
